import * as React from 'react'

import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'

import { useData } from './useData'
import type { ENTITY_TYPES } from '@sales-center/common'
import { ScheduledAppointment, AppointmentStack } from '../../../atoms'
import { Accordion, AccordionSummary, AccordionDetails } from './atoms'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function ScheduledAppointments(props: Props) {
  const { entityId, entityType } = props

  const { status, appointments } = useData({ entityId, entityType })

  return (
    <Accordion defaultExpanded>
      <AccordionSummary>
        <Typography variant="subtitle3">Scheduled Appointments</Typography>
      </AccordionSummary>

      <AccordionDetails>
        {status === 'pending' && (
          <Box mx="auto">
            <CircularProgress />
          </Box>
        )}

        {status === 'fail' && (
          <Alert severity="error">Failed to load appointments</Alert>
        )}

        {status === 'success' && (
          <>
            {appointments.length === 0 ? (
              <Alert severity="info">
                {/* {mode === 'service'
                  ? 'There are no Service Order schedule for this Location'
                  : mode === 'paid'
                    ? 'There are no Paid Estimates schedule for this Location'
                    : 'There are no Free Estimates schedule for this Location'
                } */}
                There are no appointments scheduled for this location
              </Alert>
            ) : (
              <AppointmentStack lastChildBorder>
                {appointments.map((appt) => (
                  <ScheduledAppointment key={appt.appointmentId} appt={appt} />
                ))}
              </AppointmentStack>
            )}
          </>
        )}
      </AccordionDetails>
    </Accordion>
  )
}
